<template>
  <div>
    施工中...敲敲打打...
  </div>
</template>

<script>

export default {
  name: 'UnderConstruction',
  data: function () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
